export default "__VITE_ASSET__DPwiihPr__"